<template>
  <div class="beauty-salon">
    <!-- Botón de volver a página anterior -->
    <button class="btn-back" @click="goBack">
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <polyline points="15 18 9 12 15 6" />
      </svg>
      Volver
    </button>

    <!-- Header -->
    <header class="header">
      <div class="header-container">
        <div class="header-logo" @click="goBack">
          <div class="logo-icon">💎</div>
          <div class="logo-text">Bella<span>Vida</span></div>
        </div>

        <nav class="header-nav">
          <a href="#" class="nav-item">Inicio</a>
          <a href="#" class="nav-item">Servicios</a>
          <a href="#" class="nav-item">Galería</a>
          <a href="#" class="nav-item">Contacto</a>
        </nav>

        <button class="header-cart" @click="verCarrito">
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
          >
            <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
            <line x1="3" y1="6" x2="21" y2="6" />
            <path d="M16 10a4 4 0 0 1-8 0" />
          </svg>
          <span class="cart-indicator" v-if="carrito.length">{{ carrito.length }}</span>
        </button>
      </div>
    </header>

    <!-- Hero Section -->
    <section class="hero">
      <div class="hero-bg"></div>
      <div class="hero-container">
        <div class="hero-left">
          <div class="hero-tag">✧ EXCLUSIVE BEAUTY ✧</div>
          <h1 class="hero-title">
            Descubre tu<br />
            <span>versión más radiante</span>
          </h1>
          <div class="hero-line"></div>
          <p class="hero-text">
            Tratamientos personalizados con los mejores profesionales y productos de alta
            calidad. Más de 5,000 clientas confían en nosotros.
          </p>
          <div class="hero-buttons">
            <button class="btn-primary" @click="scrollToServicios">
              Agendar cita
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
            <button class="btn-secondary" @click="verPromociones">Ver promociones</button>
          </div>
          <div class="hero-features">
            <div class="feature">
              <span class="feature-icon">✓</span>
              <span>Profesionales certificados</span>
            </div>
            <div class="feature">
              <span class="feature-icon">✓</span>
              <span>Productos premium</span>
            </div>
            <div class="feature">
              <span class="feature-icon">✓</span>
              <span>Ambiente exclusivo</span>
            </div>
          </div>
        </div>
        <div class="hero-right">
          <div class="hero-card">
            <div class="hero-card-bg"></div>
            <div class="hero-card-content">
              <div class="hero-emoji">💎✨💅</div>
              <div class="hero-card-text">
                <span class="hero-card-label">Oferta especial</span>
                <span class="hero-card-value">20% OFF</span>
                <span class="hero-card-small">Primera visita</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Stats -->
    <section class="stats">
      <div class="stats-container">
        <div class="stat-card">
          <div class="stat-number">5,000+</div>
          <div class="stat-label">Clientas felices</div>
        </div>
        <div class="stat-card">
          <div class="stat-number">8 años</div>
          <div class="stat-label">de experiencia</div>
        </div>
        <div class="stat-card">
          <div class="stat-number">4.9 ★</div>
          <div class="stat-label">Calificación</div>
        </div>
        <div class="stat-card">
          <div class="stat-number">20+</div>
          <div class="stat-label">Servicios</div>
        </div>
      </div>
    </section>

    <!-- Services -->
    <section id="servicios" class="services">
      <div class="services-container">
        <div class="services-header">
          <div class="services-icon">✦</div>
          <h2>Servicios <span>exclusivos</span></h2>
          <p>Selecciona el tratamiento perfecto para ti</p>
        </div>

        <div class="services-grid">
          <div v-for="s in servicios" :key="s.id" class="service-card">
            <div class="service-card-inner">
              <div class="service-icon">{{ s.icono }}</div>
              <h3>{{ s.nombre }}</h3>
              <p>{{ s.descripcion }}</p>
              <div class="service-card-bottom">
                <div class="service-price">S/ {{ s.precio }}</div>
                <button class="service-btn" @click="agregarAlCarrito(s)">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <circle cx="9" cy="21" r="1" />
                    <circle cx="20" cy="21" r="1" />
                    <path
                      d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Banner Oferta -->
    <section class="banner">
      <div class="banner-container">
        <div class="banner-content">
          <div class="banner-tag">✨ PROMOCIÓN ESPECIAL ✨</div>
          <h3>20% de descuento</h3>
          <p>en tu primer tratamiento de coloración</p>
          <button class="banner-btn" @click="scrollToServicios">
            Agendar ahora
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
        </div>
        <div class="banner-decoration">
          <div class="banner-circle"></div>
          <div class="banner-emoji">💖</div>
        </div>
      </div>
    </section>

    <!-- Gallery con imágenes reales -->
    <!-- Gallery con imágenes reales -->
    <section class="gallery">
      <div class="gallery-container">
        <div class="gallery-header">
          <div class="gallery-icon">⌗</div>
          <h2>Nuestro <span>trabajo</span></h2>
          <p>Resultados que inspiran</p>
        </div>
        <div class="gallery-grid">
          <div class="gallery-item" @click="showToast('✨ Próximamente más imágenes')">
            <img
              src="https://picsum.photos/id/20/400/400"
              class="gallery-img"
              alt="Corte de cabello"
            />
            <div class="gallery-overlay">
              <span>Ver más</span>
            </div>
          </div>
          <div class="gallery-item" @click="showToast('✨ Próximamente más imágenes')">
            <img
              src="https://picsum.photos/id/30/400/400"
              class="gallery-img"
              alt="Manicure"
            />
            <div class="gallery-overlay">
              <span>Ver más</span>
            </div>
          </div>
          <div class="gallery-item" @click="showToast('✨ Próximamente más imágenes')">
            <img
              src="https://picsum.photos/id/40/400/400"
              class="gallery-img"
              alt="Maquillaje"
            />
            <div class="gallery-overlay">
              <span>Ver más</span>
            </div>
          </div>
          <div class="gallery-item" @click="showToast('✨ Próximamente más imágenes')">
            <img
              src="https://picsum.photos/id/60/400/400"
              class="gallery-img"
              alt="Tratamiento facial"
            />
            <div class="gallery-overlay">
              <span>Ver más</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Testimonials -->
    <section class="testimonials">
      <div class="testimonials-container">
        <div class="testimonials-header">
          <div class="testimonials-icon">✶</div>
          <h2>Lo que dicen <span>nuestras clientas</span></h2>
        </div>
        <div class="testimonials-grid">
          <div v-for="t in testimonios" :key="t.nombre" class="testimonial-card">
            <div class="testimonial-quote">“</div>
            <p class="testimonial-text">{{ t.texto }}</p>
            <div class="testimonial-author">
              <div class="testimonial-avatar">{{ t.avatar }}</div>
              <div>
                <div class="testimonial-name">{{ t.nombre }}</div>
                <div class="testimonial-service">{{ t.servicio }}</div>
                <div class="testimonial-stars">★★★★★</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA Final -->
    <section class="cta">
      <div class="cta-container">
        <div class="cta-content">
          <h2>¿Lista para transformarte?</h2>
          <p>Agenda tu cita hoy y recibe un 20% de descuento</p>
          <button class="cta-button" @click="scrollToServicios">
            Agendar cita ahora
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <!-- Footer -->
    <!-- Footer -->
    <!-- Footer -->
    <footer class="footer">
      <div class="footer-container">
        <div class="footer-brand">
          <div class="footer-logo">💎 BellaVida</div>
          <p>Tu centro de belleza y bienestar</p>
          <div class="footer-social">
            <a
              href="#"
              class="social-link"
              @click.prevent="showToast('📷 Instagram - Próximamente')"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
              >
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <circle cx="12" cy="12" r="4.5" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
              </svg>
            </a>
            <a
              href="#"
              class="social-link"
              @click.prevent="showToast('📘 Facebook - Próximamente')"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
              >
                <path
                  d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                />
              </svg>
            </a>
            <a
              href="#"
              class="social-link"
              @click.prevent="showToast('🎵 TikTok - Próximamente')"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
              >
                <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
              </svg>
            </a>
            <a
              href="#"
              class="social-link"
              @click.prevent="showToast('💬 WhatsApp - Próximamente')"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
              >
                <path
                  d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
                />
              </svg>
            </a>
          </div>
        </div>
        <div class="footer-links">
          <h4>Servicios</h4>
          <a href="#">Corte y peinado</a>
          <a href="#">Coloración</a>
          <a href="#">Manicure y pedicure</a>
          <a href="#">Tratamientos faciales</a>
        </div>
        <div class="footer-links">
          <h4>Horario</h4>
          <p>Lunes a Viernes: 9am - 8pm</p>
          <p>Sábados: 10am - 6pm</p>
          <p>Domingos: Cerrado</p>
        </div>
        <div class="footer-links">
          <h4>Contacto</h4>
          <p>📞 +51 928 180 748</p>
          <p>📧 hola@bellavida.com</p>
          <p>📍 Miraflores, Lima</p>
        </div>
      </div>
      <div class="footer-bottom">
        <p>© 2024 BellaVida — Todos los derechos reservados</p>
      </div>
    </footer>

    <!-- Cart Floating -->
    <div class="cart-float" @click="verCarrito">
      <div class="cart-float-inner">
        <div class="cart-float-icon">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            stroke-width="1.5"
          >
            <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
            <line x1="3" y1="6" x2="21" y2="6" />
            <path d="M16 10a4 4 0 0 1-8 0" />
          </svg>
          <span class="cart-float-badge" v-if="carrito.length">{{ carrito.length }}</span>
        </div>
        <span class="cart-float-total">S/ {{ totalCarrito }}</span>
      </div>
    </div>

    <!-- Modal Carrito -->
    <div v-if="mostrarCarrito" class="modal" @click.self="cerrarCarrito">
      <div class="modal-container">
        <div class="modal-header">
          <h3>Tu selección</h3>
          <button class="modal-close" @click="cerrarCarrito">✕</button>
        </div>
        <div class="modal-body">
          <div v-if="carrito.length === 0" class="modal-empty">
            <div class="empty-icon">🛍️</div>
            <p>Tu carrito está vacío</p>
          </div>
          <div v-else>
            <div v-for="(item, idx) in carrito" :key="item.id" class="modal-item">
              <div class="modal-item-info">
                <div class="modal-item-name">{{ item.nombre }}</div>
                <div class="modal-item-price">S/ {{ item.precio }}</div>
              </div>
              <div class="modal-item-controls">
                <button class="qty-control" @click="disminuirCantidad(idx)">−</button>
                <span class="qty-value">{{ item.cantidad }}</span>
                <button class="qty-control" @click="aumentarCantidad(idx)">+</button>
                <button class="item-remove" @click="eliminarDelCarrito(idx)">🗑️</button>
              </div>
            </div>
            <div class="modal-total">
              <span>Total</span>
              <strong>S/ {{ totalCarrito }}</strong>
            </div>
            <button class="modal-button" @click="irAPagar">Continuar →</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Pago -->
    <div v-if="mostrarPago" class="modal" @click.self="cerrarPago">
      <div class="modal-container payment-modal">
        <div class="modal-header">
          <h3>Completar reserva</h3>
          <button class="modal-close" @click="cerrarPago">✕</button>
        </div>
        <div class="modal-body">
          <div class="payment-summary">
            <div v-for="item in carrito" :key="item.id" class="payment-row">
              <span>{{ item.nombre }} x{{ item.cantidad }}</span>
              <span>S/ {{ item.precio * item.cantidad }}</span>
            </div>
            <div class="payment-total">Total: S/ {{ totalCarrito }}</div>
          </div>
          <input
            type="text"
            v-model="reserva.nombre"
            placeholder="Nombre completo"
            class="payment-input"
          />
          <input
            type="email"
            v-model="reserva.email"
            placeholder="Correo electrónico"
            class="payment-input"
          />
          <input
            type="tel"
            v-model="reserva.telefono"
            placeholder="Teléfono"
            class="payment-input"
          />
          <input type="date" v-model="reserva.fecha" class="payment-input" />
          <button class="payment-button" @click="confirmarReserva">
            Confirmar reserva
          </button>
        </div>
      </div>
    </div>

    <!-- Toast -->
    <div v-if="toastVisible" class="toast">{{ toastMensaje }}</div>
  </div>
</template>

<script>
export default {
  name: "BeautySalon",
  data() {
    return {
      mostrarCarrito: false,
      mostrarPago: false,
      toastVisible: false,
      toastMensaje: "",
      carrito: [],
      reserva: { nombre: "", email: "", telefono: "", fecha: "" },
      servicios: [
        {
          id: 1,
          nombre: "Corte de cabello",
          icono: "✂️",
          descripcion: "Corte moderno y tendencia",
          precio: 50,
        },
        {
          id: 2,
          nombre: "Coloración",
          icono: "🎨",
          descripcion: "Tinte, mechas o balayage",
          precio: 120,
        },
        {
          id: 3,
          nombre: "Manicure",
          icono: "💅",
          descripcion: "Manicure clásico o semipermanente",
          precio: 40,
        },
        {
          id: 4,
          nombre: "Pedicure",
          icono: "🦶",
          descripcion: "Pedicure con hidratación",
          precio: 45,
        },
        {
          id: 5,
          nombre: "Tratamiento facial",
          icono: "✨",
          descripcion: "Limpieza profunda",
          precio: 90,
        },
        {
          id: 6,
          nombre: "Maquillaje",
          icono: "💄",
          descripcion: "Maquillaje social o de novia",
          precio: 80,
        },
      ],
      testimonios: [
        {
          nombre: "María G.",
          texto: "Excelente servicio, volveré sin duda",
          avatar: "👩",
          servicio: "Coloración",
        },
        {
          nombre: "Lucía R.",
          texto: "Profesionales y muy amables",
          avatar: "👩",
          servicio: "Corte",
        },
        {
          nombre: "Carmen T.",
          texto: "El mejor salón de Lima",
          avatar: "👩",
          servicio: "Manicure",
        },
      ],
    };
  },
  computed: {
    totalCarrito() {
      return this.carrito.reduce((t, i) => t + i.precio * i.cantidad, 0);
    },
  },
  methods: {
    goBack() {
      window.location.href = "/portafolio";
    },
    scrollToServicios() {
      document.getElementById("servicios").scrollIntoView({ behavior: "smooth" });
    },
    verPromociones() {
      this.showToast("🎁 20% OFF en tu primera visita");
    },
    agregarAlCarrito(s) {
      const exist = this.carrito.find((i) => i.id === s.id);
      if (exist) exist.cantidad++;
      else this.carrito.push({ ...s, cantidad: 1 });
      this.showToast(`✨ ${s.nombre} agregado`);
    },
    aumentarCantidad(i) {
      this.carrito[i].cantidad++;
    },
    disminuirCantidad(i) {
      if (this.carrito[i].cantidad > 1) this.carrito[i].cantidad--;
      else this.eliminarDelCarrito(i);
    },
    eliminarDelCarrito(i) {
      this.carrito.splice(i, 1);
      this.showToast("🗑️ Eliminado");
    },
    verCarrito() {
      this.mostrarCarrito = true;
    },
    cerrarCarrito() {
      this.mostrarCarrito = false;
    },
    irAPagar() {
      this.mostrarCarrito = false;
      this.mostrarPago = true;
    },
    cerrarPago() {
      this.mostrarPago = false;
    },
    confirmarReserva() {
      if (!this.reserva.nombre || !this.reserva.fecha) {
        this.showToast("⚠️ Completa tus datos");
        return;
      }
      this.showToast(`🌸 ¡Gracias ${this.reserva.nombre}! Te esperamos`);
      setTimeout(() => {
        this.carrito = [];
        this.mostrarPago = false;
        this.reserva = { nombre: "", email: "", telefono: "", fecha: "" };
      }, 2000);
    },
    showToast(msg) {
      this.toastMensaje = msg;
      this.toastVisible = true;
      setTimeout(() => {
        this.toastVisible = false;
      }, 2500);
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.beauty-salon {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  background: radial-gradient(
      circle at 12% 12%,
      rgba(231, 181, 194, 0.16),
      transparent 18%
    ),
    radial-gradient(circle at 88% 16%, rgba(255, 255, 255, 0.08), transparent 15%),
    linear-gradient(180deg, #090410 0%, #0f061b 40%, #0b0812 100%);
  min-height: 100vh;
  color: #f3f3f7;
}

::selection {
  background: rgba(232, 180, 184, 0.35);
  color: #111;
}

/* Botón de volver */
.btn-back {
  position: fixed;
  top: 90px;
  left: 30px;
  z-index: 101;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(16px);
  border: 1px solid rgba(232, 180, 184, 0.25);
  color: #f3f3f7;
  padding: 12px 20px;
  border-radius: 999px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 500;
  transition: transform 0.25s ease, background 0.25s ease, color 0.25s ease;
}

.btn-back:hover {
  background: #e8b4b8;
  color: #0a0a0a;
  transform: translateY(-2px);
}

.btn-back svg {
  stroke: #f3f3f7;
  transition: stroke 0.25s ease;
}

.btn-back:hover svg {
  stroke: #0a0a0a;
}

/* Header */
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(8, 8, 18, 0.92);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  z-index: 100;
  padding: 18px 0;
}

.header-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 36px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 32px;
}

.header-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.logo-icon {
  font-size: 30px;
  color: #f7c2d5;
}

.logo-text {
  font-size: 20px;
  font-weight: 300;
  letter-spacing: 2px;
  color: #f7f5fb;
}

.logo-text span {
  font-weight: 600;
  color: #f7c2d5;
}

.header-nav {
  display: flex;
  gap: 36px;
}

.nav-item {
  color: #c0c0c8;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1px;
  transition: color 0.25s ease;
}

.nav-item:hover {
  color: #f7c2d5;
}

.header-cart {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 999px;
  padding: 10px;
  cursor: pointer;
  transition: transform 0.25s ease, background 0.25s ease;
}

.header-cart:hover {
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.14);
}

.header-cart svg {
  stroke: #f7f5fb;
}

.cart-indicator {
  position: absolute;
  top: 4px;
  right: 4px;
  background: #f7c2d5;
  color: #0a0a0a;
  font-size: 10px;
  font-weight: 700;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Hero */
.hero {
  min-height: calc(100vh - 96px);
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding: 150px 0 80px;
}

.hero-bg {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(
      circle at 20% 20%,
      rgba(247, 194, 213, 0.13),
      transparent 20%
    ),
    radial-gradient(circle at 85% 18%, rgba(255, 255, 255, 0.08), transparent 12%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.02), transparent 40%);
  pointer-events: none;
}

.hero-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 36px;
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) 0.9fr;
  gap: 64px;
  align-items: center;
  position: relative;
  z-index: 2;
}

.hero-left {
  max-width: 640px;
}

.hero-tag {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: #f7c2d5;
  margin-bottom: 26px;
}

.hero-title {
  font-size: clamp(3.6rem, 5vw, 5.2rem);
  font-weight: 700;
  line-height: 1.02;
  color: #fff;
  margin-bottom: 28px;
}

.hero-title span {
  display: block;
  background: linear-gradient(135deg, #f7c2d5 0%, #ffffff 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.hero-line {
  width: 72px;
  height: 3px;
  background: linear-gradient(90deg, #f7c2d5, #ffffff);
  margin-bottom: 32px;
  border-radius: 999px;
}

.hero-text {
  max-width: 520px;
  font-size: 16px;
  line-height: 1.85;
  color: #ced0dd;
  margin-bottom: 42px;
}

.hero-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  margin-bottom: 40px;
}

.btn-primary,
.btn-secondary,
.banner-btn,
.cta-button,
.modal-button,
.payment-button {
  border-radius: 999px;
  transition: transform 0.25s ease, background 0.25s ease, box-shadow 0.25s ease,
    color 0.25s ease;
}

.btn-primary {
  background: #f7c2d5;
  color: #0d0b13;
  border: none;
  padding: 15px 32px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 22px 45px rgba(247, 194, 213, 0.18);
}

.btn-primary:hover {
  transform: translateY(-2px);
  background: #ffe4ef;
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.08);
  color: #eaeaf5;
  border: 1px solid rgba(255, 255, 255, 0.12);
  padding: 15px 32px;
  font-weight: 500;
  cursor: pointer;
}

.btn-secondary:hover {
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(247, 194, 213, 0.28);
  color: #f7c2d5;
}

.hero-features {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.feature {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #c8c8d5;
}

.feature-icon {
  color: #f7c2d5;
  font-weight: 700;
}

/* Hero Card */
.hero-right {
  position: relative;
}

.hero-card {
  position: relative;
  width: 100%;
  max-width: 440px;
  min-height: 520px;
  margin: 0 auto;
  border-radius: 40px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.1),
    rgba(255, 255, 255, 0.02)
  );
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 40px 90px rgba(0, 0, 0, 0.28);
  overflow: hidden;
  backdrop-filter: blur(24px);
}

.hero-card::before {
  content: "";
  position: absolute;
  top: -70px;
  right: -70px;
  width: 190px;
  height: 190px;
  border-radius: 50%;
  background: rgba(247, 194, 213, 0.18);
  filter: blur(26px);
}

.hero-card-bg {
  position: absolute;
  inset: 0;
  background: radial-gradient(
      circle at 20% 20%,
      rgba(255, 255, 255, 0.08),
      transparent 38%
    ),
    linear-gradient(180deg, rgba(255, 255, 255, 0.08), transparent 60%);
  pointer-events: none;
}

.hero-card-content {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 48px 28px;
  gap: 24px;
}

.hero-emoji {
  font-size: 72px;
}

.hero-card-text {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.hero-card-label {
  font-size: 12px;
  letter-spacing: 0.24em;
  color: #f7c2d5;
  text-transform: uppercase;
}

.hero-card-value {
  font-size: 52px;
  font-weight: 700;
  color: #ffffff;
}

.hero-card-small {
  font-size: 14px;
  color: #cadae6;
}

/* Stats */
.stats {
  padding: 80px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.stats-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 36px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 28px;
}

.stat-card {
  text-align: center;
  padding: 24px 20px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 24px;
}

.stat-number {
  font-size: 38px;
  font-weight: 700;
  color: #f7c2d5;
  margin-bottom: 10px;
}

.stat-label {
  font-size: 14px;
  color: #c8c8d5;
  letter-spacing: 0.4px;
}

/* Services */
.services {
  padding: 100px 0;
}

.services-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 36px;
}

.services-header,
.gallery-header,
.testimonials-header {
  text-align: center;
  margin-bottom: 60px;
}

.services-icon,
.gallery-icon,
.testimonials-icon {
  font-size: 40px;
  color: #f7c2d5;
  margin-bottom: 16px;
}

.services-header h2,
.gallery-header h2,
.testimonials-header h2 {
  font-size: clamp(2.6rem, 4vw, 3.4rem);
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 14px;
  line-height: 1.05;
}

.services-header h2 span,
.gallery-header h2 span,
.testimonials-header h2 span {
  color: #f7c2d5;
}

.services-header p,
.gallery-header p,
.testimonials-header p {
  color: #c8c8d5;
  font-size: 16px;
  max-width: 600px;
  margin: 0 auto;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px;
}

.service-card {
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.07),
    rgba(255, 255, 255, 0.02)
  );
  backdrop-filter: blur(16px);
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
}

.service-card:hover {
  transform: translateY(-8px);
  border-color: rgba(247, 194, 213, 0.25);
  box-shadow: 0 24px 50px rgba(0, 0, 0, 0.18);
}

.service-card-inner {
  padding: 40px 32px;
}

.service-icon {
  font-size: 44px;
  margin-bottom: 22px;
}

.service-card h3 {
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 14px;
}

.service-card p {
  font-size: 15px;
  color: #c8c8d5;
  line-height: 1.8;
  margin-bottom: 28px;
}

.service-card-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.service-price {
  font-size: 24px;
  font-weight: 700;
  color: #f7c2d5;
}

.service-btn {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(247, 194, 213, 0.13);
  border: 1px solid rgba(247, 194, 213, 0.25);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease, background 0.3s ease;
}

.service-btn svg {
  stroke: #f7c2d5;
}

.service-btn:hover {
  transform: translateY(-2px);
  background: #f7c2d5;
}

.service-btn:hover svg {
  stroke: #0a0a0a;
}

/* Banner */
.banner {
  padding: 80px 0;
}

.banner-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 36px;
  background: linear-gradient(
    135deg,
    rgba(247, 194, 213, 0.12),
    rgba(255, 255, 255, 0.05)
  );
  border-radius: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  position: relative;
  gap: 30px;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.banner-content {
  padding: 52px 48px;
  position: relative;
  z-index: 1;
}

.banner-tag {
  font-size: 12px;
  letter-spacing: 0.3em;
  color: #f7c2d5;
  margin-bottom: 14px;
  text-transform: uppercase;
}

.banner-content h3 {
  font-size: clamp(2.4rem, 3vw, 3.4rem);
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 12px;
}

.banner-content p {
  font-size: 16px;
  color: #d5d5e1;
  margin-bottom: 28px;
}

.banner-btn {
  background: #f7c2d5;
  color: #0a0a0a;
  border: none;
  padding: 14px 30px;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.banner-btn:hover {
  transform: translateY(-2px);
  background: #ffe4ef;
}

.banner-decoration {
  position: relative;
  width: 220px;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-circle {
  position: absolute;
  width: 220px;
  height: 220px;
  background: radial-gradient(circle, rgba(247, 194, 213, 0.28) 0%, transparent 58%);
  border-radius: 50%;
}

.banner-emoji {
  position: absolute;
  font-size: 62px;
}

/* Gallery */
.gallery {
  padding: 100px 0;
}

.gallery-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 36px;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 22px;
}

.gallery-item {
  aspect-ratio: 1;
  border-radius: 26px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.18);
  transition: transform 0.35s ease, border-color 0.35s ease;
}

.gallery-item:hover {
  transform: translateY(-6px);
  border-color: rgba(247, 194, 213, 0.3);
}

.gallery-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s ease;
}

.gallery-item:hover .gallery-img {
  transform: scale(1.08);
}

.gallery-overlay {
  position: absolute;
  inset: 0;
  background: rgba(232, 180, 184, 0.86);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.25s ease;
}

.gallery-item:hover .gallery-overlay {
  opacity: 1;
}

.gallery-overlay span {
  color: #0a0a0a;
  font-weight: 700;
  font-size: 14px;
}

/* Testimonials */
.testimonials {
  padding: 100px 0;
  background: linear-gradient(180deg, transparent 0%, rgba(247, 194, 213, 0.05) 100%);
}

.testimonials-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 36px;
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 30px;
}

.testimonial-card {
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.06),
    rgba(255, 255, 255, 0.02)
  );
  backdrop-filter: blur(14px);
  border-radius: 28px;
  padding: 34px 30px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: transform 0.3s ease, border-color 0.3s ease;
}

.testimonial-card:hover {
  transform: translateY(-6px);
  border-color: rgba(247, 194, 213, 0.25);
}

.testimonial-quote {
  font-size: 52px;
  color: rgba(247, 194, 213, 0.35);
  opacity: 0.95;
  margin-bottom: 18px;
}

.testimonial-text {
  font-size: 15px;
  line-height: 1.78;
  color: #d7d7e5;
  margin-bottom: 26px;
  font-style: italic;
}

.testimonial-author {
  display: flex;
  align-items: center;
  gap: 16px;
}

.testimonial-avatar {
  font-size: 42px;
}

.testimonial-name {
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 4px;
}

.testimonial-service {
  font-size: 13px;
  color: #f7c2d5;
  margin-bottom: 4px;
}

.testimonial-stars {
  font-size: 11px;
  letter-spacing: 1px;
  color: #ffd166;
}

/* CTA */
.cta {
  padding: 100px 0;
  position: relative;
  overflow: hidden;
}

.cta::before {
  content: "";
  position: absolute;
  top: -20%;
  left: 50%;
  width: 520px;
  height: 520px;
  transform: translateX(-50%);
  background: radial-gradient(circle, rgba(247, 194, 213, 0.16), transparent 55%);
  pointer-events: none;
}

.cta-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 36px;
}

.cta-content {
  text-align: center;
  max-width: 640px;
  margin: 0 auto;
}

.cta-content h2 {
  font-size: clamp(3rem, 4vw, 4.4rem);
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 18px;
}

.cta-content p {
  font-size: 18px;
  color: #c8c8d5;
  margin-bottom: 32px;
}

.cta-button {
  background: #f7c2d5;
  color: #0a0a0a;
  border: none;
  padding: 16px 44px;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
}

.cta-button:hover {
  transform: translateY(-2px);
  background: #ffdced;
}

/* Footer */
.footer {
  background: #0a0a0a;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding: 60px 0 30px;
  margin-top: 60px;
}

.footer-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 36px;
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1fr;
  gap: 48px;
}

.footer-logo {
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 16px;
}

.footer-brand {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.footer-brand p {
  color: #9a9bb1;
  font-size: 14px;
  line-height: 1.8;
  margin-bottom: 24px;
}

.footer-social {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.social-link {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.25s ease, background 0.25s ease;
  text-decoration: none;
  cursor: pointer;
  line-height: 0;
}

.social-link:hover {
  background: #f7c2d5;
  transform: translateY(-3px);
}

.social-link svg {
  width: 18px;
  height: 18px;
  display: block;
  stroke: #c7c7d3;
  transition: stroke 0.25s ease;
}

.social-link:hover svg {
  stroke: #0a0a0a;
}

.footer-links h4 {
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 20px;
}

.footer-links a,
.footer-links p {
  display: block;
  color: #9a9bb1;
  font-size: 14px;
  margin-bottom: 12px;
  line-height: 1.8;
  text-decoration: none;
  transition: color 0.25s ease;
}

.footer-links a:hover {
  color: #f7c2d5;
}

.footer-bottom {
  text-align: center;
  padding-top: 40px;
  margin-top: 50px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  font-size: 13px;
  color: #6f6f7f;
}

/* Cart Float */
.cart-float {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 99;
  cursor: pointer;
}

.cart-float-inner {
  background: #f7c2d5;
  padding: 14px 24px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  gap: 14px;
  transition: transform 0.25s ease;
}

.cart-float-inner:hover {
  transform: scale(1.04);
}

.cart-float-icon {
  position: relative;
}

.cart-float-badge {
  position: absolute;
  top: -8px;
  right: -12px;
  background: #0a0a0a;
  color: #f7c2d5;
  font-size: 10px;
  font-weight: 700;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cart-float-total {
  color: #0a0a0a;
  font-weight: 700;
  font-size: 14px;
}

/* Modal */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(4, 4, 12, 0.85);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-container {
  background: linear-gradient(180deg, rgba(16, 16, 34, 0.98), rgba(20, 18, 45, 0.98));
  border-radius: 28px;
  max-width: 520px;
  width: 92%;
  max-height: 82vh;
  overflow-y: auto;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 32px 90px rgba(0, 0, 0, 0.35);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 26px 24px 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.modal-header h3 {
  font-size: 20px;
  font-weight: 700;
  color: white;
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #c8c8d5;
}

.modal-body {
  padding: 24px;
}

.modal-empty {
  text-align: center;
  padding: 40px;
}

.empty-icon {
  font-size: 60px;
  margin-bottom: 18px;
}

.modal-empty p {
  color: #c8c8d5;
}

.modal-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.modal-item-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.modal-item-name {
  font-weight: 600;
  color: white;
}

.modal-item-price {
  font-size: 13px;
  color: #f7c2d5;
}

.modal-item-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

.qty-control {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  border: none;
  color: white;
  cursor: pointer;
}

.qty-value {
  color: white;
  min-width: 24px;
  text-align: center;
}

.item-remove {
  background: none;
  border: none;
  cursor: pointer;
}

.modal-total {
  display: flex;
  justify-content: space-between;
  padding: 22px 0;
  margin-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  color: white;
  font-size: 18px;
}

.modal-total strong {
  color: #f7c2d5;
}

.modal-button {
  width: 100%;
  background: #f7c2d5;
  color: #0a0a0a;
  border: none;
  padding: 16px;
  border-radius: 999px;
  font-weight: 700;
  cursor: pointer;
}

.payment-summary {
  background: rgba(255, 255, 255, 0.04);
  padding: 18px;
  border-radius: 18px;
  margin-bottom: 24px;
}

.payment-row {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  color: #c8c8d5;
  font-size: 14px;
}

.payment-total {
  padding-top: 14px;
  margin-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  font-weight: 700;
  color: white;
}

.payment-input {
  width: 100%;
  padding: 14px 16px;
  margin-bottom: 14px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  color: white;
  font-size: 14px;
}

.payment-input:focus {
  outline: none;
  border-color: #f7c2d5;
}

.payment-input::placeholder {
  color: #8f92a2;
}

.payment-button {
  width: 100%;
  background: #f7c2d5;
  color: #0a0a0a;
  border: none;
  padding: 14px;
  border-radius: 999px;
  font-weight: 700;
  cursor: pointer;
}

/* Toast */
.toast {
  position: fixed;
  bottom: 100px;
  right: 30px;
  background: #f7c2d5;
  color: #0a0a0a;
  padding: 14px 26px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  z-index: 1001;
  animation: slideIn 0.3s ease;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.24);
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Responsive */
@media (max-width: 1200px) {
  .header-container,
  .hero-container,
  .stats-container,
  .services-container,
  .banner-container,
  .gallery-container,
  .testimonials-container,
  .cta-container,
  .footer-container {
    padding: 0 24px;
  }

  .hero-container {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .hero-title {
    font-size: clamp(3rem, 7vw, 4.6rem);
  }

  .hero-text {
    margin-left: auto;
    margin-right: auto;
  }

  .hero-line,
  .hero-buttons,
  .hero-features {
    margin-left: auto;
    margin-right: auto;
  }
}

@media (max-width: 1024px) {
  .hero {
    padding-top: 130px;
  }

  .services-grid,
  .testimonials-grid {
    grid-template-columns: 1fr;
  }

  .gallery-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .footer-container {
    grid-template-columns: 1fr;
    gap: 40px;
    text-align: center;
  }

  .footer-social {
    justify-content: center;
  }

  .footer-links {
    text-align: center;
  }

  .stats-container {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .banner-container {
    flex-direction: column;
  }

  .banner-decoration {
    margin-right: 0;
    margin-top: 24px;
  }

  .hero-card {
    max-width: 100%;
    min-height: 460px;
  }
}

@media (max-width: 720px) {
  .header-container {
    flex-direction: column;
    align-items: stretch;
    gap: 18px;
  }

  .nav-item {
    display: none;
  }

  .btn-back {
    left: 16px;
    top: 80px;
    padding: 10px 16px;
    font-size: 13px;
  }

  .hero {
    padding-top: 120px;
  }

  .hero-title {
    font-size: clamp(2.6rem, 10vw, 3.6rem);
  }

  .hero-buttons {
    justify-content: center;
  }

  .services-grid,
  .gallery-grid,
  .testimonials-grid {
    grid-template-columns: 1fr;
  }

  .banner-container {
    padding: 32px 24px;
  }

  .banner-content,
  .cta-content,
  .modal-body {
    padding: 0;
  }

  .hero-card {
    border-radius: 30px;
  }
}
</style>
